<template>
  <tea-main>
    <template slot="left">
      <div class="teaLeft">
        <div class="info">
          <img :src="!userInfo.profile_picture ? userImg : userInfo.profile_picture"
               alt=""
               @error="imgErr">
          <p class="name">{{ userInfo.name }}</p>
          <p class="num">培训班数量：{{classNum}}</p>
          <p class="tea_history" @click="showPromote" v-if="isShowPromote">
            <el-button type="primary" class="promote_tea" :loading="isLoading" :disabled="isLoading">D级讲师晋升经历</el-button>
          </p>
          <p class="tea_history" @click="gotoMyTutorial" >
            <el-button type="primary" class="promote_tea" >FIFA/CFA讲师课程</el-button>
          </p>
        </div>
      </div>
    </template>
    <template slot="right">
      <div class="teaRight">
        <div class="rightHead">
          <!--<p><strong>培训班管理</strong></p>-->
          <div class="selectWrap">
            <select class="search"
              v-model="search.class_train_type"
              @change="change_req">
              <option value="">全部类型</option>
              <option v-for="(item, index) in filterData.class_train_types"
                :key="index"
                :value="item.value">{{ item.key }}
              </option>
            </select>
            <select class="search"
              v-model="search.class_level"
              @change="change_req">
              <option value="">全部级别</option>
              <option v-for="(item, index) in filterData.class_levels"
                :key="index"
                :value="item.value">{{ item.key }}
              </option>
            </select>
            <select class="search"
                    v-model="search.class_province_id"
                    @change="updateCity">
              <option value="">全部省份</option>
              <option v-for="(item, index) in filterData.area"
                      :key="index"
                      :value="item.id">{{ item.regionName }}
              </option>
            </select>
            <select class="search"
                    v-model="search.class_city_id"
                    @change="change_req">
              <option value="">全部城市</option>
              <option v-for="(item, index) in filterData.city"
                      :key="index"
                      :value="item.id">{{ item.regionName }}
              </option>
            </select>
            <select class="search"
                    v-model="search.class_create_time"
                    @change="change_req">
              <option value="">全部培训日期</option>
              <option v-for="(item, index) in filterData.date"
                      :key="index"
                      :value="item.value">{{ item.key }}
              </option>
            </select>
            <select class="search"
                    v-model="search.class_status"
                    @change="change_req">
              <option value="">全部状态</option>
              <option v-for="(item, index) in filterData.status"
                      :key="index"
                      :value="item.value">{{ item.key }}
              </option>
            </select>
          </div>
        </div>
        <div class="rightBody">
          <template v-if="showList">
            <div class="scrollArea">
              <vue-scroll :ops="ops" ref="vs">
                <div class="tbodyWrap">
                  <div class="tbody">
                    <div class="tr"
                         v-for="(item, index) in list"
                         :key="index">
                      <!--<div class="td term">
                        <span>第</span>
                        <span>{{ item.periods }}</span>
                        <span>期</span>
                      </div>-->
                      <div class="td detail">
                        <p class="title">
                          <span v-if="item.is_special_train === 1">【快】</span>
                          {{ item.name }}
                        </p>
                        <div class="blockWrap">
                          <div class="left">
                            <div class="wrap">
                              <div class="imgWrap">
                                <img :src="!item.moment_picture ? classImg : item.moment_picture"
                                     @error="imgListErr(index)"
                                     alt="">
                                <yioks-status :status="item.status"></yioks-status>
                              </div>
                              <div class="infoWrap">
                                <p>培训日期：{{item.start_date | time(false)}} 至 {{item.end_date | time(false)}}</p>
                                <p>培训班级别：{{item.class_level}} 级 （{{item.class_train_type | classType}}）</p>
                                <p>主讲师：{{ item.teacher_off_name ? item.teacher_off_name : "足协指派" }}</p>
                                <p v-if="item.teacher_name != '' && item.teacher_name !=null">助理讲师：{{ item.teacher_name }}</p>
                                <p v-if="(item.class_level ==='C' || item.class_level ==='D') && item.intern_teacher != ''   && item.class_train_type === 'train' ">实习讲师：{{ item.intern_teacher }}</p>
                                <p v-if="item.lecturer_assistant_name != '' &&  (item.class_level ==='A' || item.class_level ==='B' || item.class_train_type === 'continue_education') ">讲师助理：{{ item.lecturer_assistant_name }}</p>
                                <p v-if="item.hours">学时：{{ item.hours }}</p>
                              </div>
                            </div>
                          </div>
                          <div class="right">
                            <div class="btn"
                                 @click="lookOver(item.c_id)">
                              <p>查看详情</p>
                            </div>
                            <div class="btn"
                              @click="viewResult(item.msg_info)"
                              v-if="Number(item.isShowAuditMsg) === 1">
                              <p>成绩审核结果</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </vue-scroll>
            </div>
            <div id="paging">
              <yioks-paging :paging="paging"
                            @goto-page="gotoPage($event)"></yioks-paging>
            </div>
          </template>
          <yioks-empty v-show="showEmpty" :h="'645px'"></yioks-empty>
          <el-dialog width="350px"
            :visible.sync="verifyResult"
            custom-class="verify_result_dialog"
            :close-on-click-modal="false">
            <div class="verifyResult">
              <p>审核结果：{{verifyMsg.audit_status | verifyStatus}}</p>
              <p>
                <span>审核理由：</span>
                <span>{{verifyMsg.audit_msg||'--'}}</span>
              </p>
            </div>
          </el-dialog>

          <!-- 完善登录信息弹框 -->
            <el-dialog class="eval-dialog"
               :visible.sync="allDisabled"
               title
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               :show-close="false"
               width="460px"
               center>
      <div class="to-eval">
        <div class="img">
          <img src="@/assets/images/evaluation_tips.png" alt>
        </div>
        <div class="tips">
          <p v-html="tips.title"></p>
        </div>
        <el-button type="primary" @click="gotoSetting">{{tips.button_text}}</el-button>
      </div>
    </el-dialog>
          <!--    查看晋升经历弹框     -->
          <el-dialog
                  class="detail-info-dia-date"
                  :title="EvaluateTitle"
                  :visible.sync="ShowEvaluate"
                  :close-on-click-modal="false"
                  width="800px"
                  top="12vh"
          >
            <div class="promoteWrap" >
              <select v-model="promoteNum"
                      v-if="promoteType === 'promote' && promoteList.length !== 0"
                      @change="getPromoteData()">
                <!-- <option value="">全部级别</option> -->
                <option v-for="(item,index) in promoteList"
                        :key="index"
                        :value="item.promote_number">
                  第 {{item.promote_number}} 次
                </option>
              </select>
            </div>
            <div class="scroll-wrap">
              <vue-scroll :ops="disEvaluateScrollOpt" ref="vScroll">
                <teacher-evaluate-view v-if="ShowEvaluate" :teacherId="teacherId" :cId="cId" :promoteType="promoteType"/>
              </vue-scroll>
            </div>
          </el-dialog>
          <el-dialog
                  :title="EvaluateTitle"
                  class="detail-info-empty"
                  width="800px"
                  top="12vh"
                  :visible.sync="showPromoteEmpty"
                  :close-on-click-modal="false">
                  <div class="empty">
                    <yioks-empty-grey v-show="showPromoteEmpty" :h="'530px'"></yioks-empty-grey>
                  </div>
          </el-dialog>
        </div>
        <!-- <update-dia :if-show='ifUpDiaShow' @close='closeDia'></update-dia> -->
      </div>
    </template>
  </tea-main>
</template>

<script>
  import ops from '@/assets/js/vuescrollOption';
  import evaluationNum from '@/minix/evaluation-number';
  import userImg from "@/assets/images/person.png";
  import classImg from "@/assets/images/class_logo.png";
  import {userClassList} from "@/api/common/api";
  import {area_list} from "@/assets/js/region";
  import {date, user_status,classLevelList,class_train_type_list} from "@/assets/js/select";
  import {teacher_info_check } from '@/api/training_teacher/api';
  import {teacher_promote_list} from '@/api/training_teacher/api';
  import {typeFilters} from "@/assets/js/status";
  export default {
    name: "class-list",
    mixins: [evaluationNum],
    beforeCreate() {
      localStorage.getItem('sys_update') === null && localStorage.setItem('sys_update', '1');
    },
    data() {
      return {
        ifUpDiaShow: localStorage.getItem('sys_update') === '1',
        ops: ops(),
        disEvaluateScrollOpt: ops(true),
        userImg: userImg,
        classImg: classImg,
        userInfo: this.$store.state.userInfo,
        promoteType:'',
        promoteNum:'',
        teacherId:'',
        ShowEvaluate:false,
        showPromoteEmpty:false,
        cId:'',
        promoteList:[],
        EvaluateTitle:"中国足协教练员培训班助理讲师" + this.$store.state.userInfo.name + "晋升经历",
        classNum:0,
        list: [],
        isShowPromote:false,
        isLoading:false,
        showList: false,
        showEmpty: false,
        verifyResult :false,
        verifyMsg: {},
        page: 1,
        paging: {
          start: 0,
          prePage: 1, // 一页多少条数据
          total: 1, // 总页数
          size: 3, // 页码显示限制
          last: true, // 尾页
          next: true, // 下一页
          first: true, // 首页
          previous: true, // 上一页
          jump: true
        },
        search: {
          class_province_id: "",
          class_city_id: "",
          class_create_time: "",
          class_status: "",
          class_level: "",
          class_train_type: "",
        },
        filterData: {
          area: area_list,
          city: [],
          date: date,
          status: user_status,
          class_levels: classLevelList,
          class_train_types: class_train_type_list
        },
        tips:{
          title:"",
          button_text:"",
          show_type:"",
        },
        allDisabled: false,
      };
    },
    components: {
      "tea-main": () => import("@/components/LayOut/Common/left-right"),
      "yioks-paging": () => import("@/components/Pagination/Page"),
      "yioks-empty": () => import("@/components/Tips/Empty"),
      "yioks-empty-grey": () => import("@/components/Tips/Empty-grey"),
      "yioks-status": () => import("@/components/Tips/Status"),
      "update-dia": () => import("@/components/UpdateDia/UpdateDia"),
      'teacher-evaluate-view' : () => import("@/components/score/components/teacher-evaluate-view")
    },
    filters: {
      verifyStatus(status) {
        const statusHash = {
          "pass": "通过",
          "repulse": "拒绝",
        };
        return !status ? "--" : statusHash[status];
      },
      classType(level) {
        return typeFilters(level);
      },
    },
    created() {
      this.setData();
      this.isEvaled();
      this.getEvaNum();
      this.getClassList();
    },
    methods: {
      closeDia() {
        localStorage.setItem('sys_update', '0');
        this.ifUpDiaShow = false;
      },
      gotoSetting(){

          this.$router.push({
            path: "vita",
            query: {}
          });

      },
      isEvaled() {
        teacher_info_check().then(({data}) => {
          let perfect_info = data.result.perfect_info
          if(Number(perfect_info)===1){
            this.allDisabled =true
            this.tips.title="需要完善讲师资料<br/>资料内容可在“设置-->资料设置”中修改。";
            this.tips.button_text="前往完善资料";
            this.tips.show_type="perfect_info";
          }
          // if (data.status === 0) {
          //   this.allDisabled = data.result.perfect_info === 1 || data.result.eva_show === 1 ;
          //   if(data.result.perfect_info === 1){
          //     this.tips.title="首次登录需要完善个人资料<br/>资料内容在培训结束前均可在“设置-->资料设置”中修改。";
          //     this.tips.button_text="前往完善资料";
          //     this.tips.show_type="perfect_info";
          //   }else{
          //     this.tips.title="培训班即将结束，请您填写问卷调查。";
          //     this.tips.button_text="前往问卷调查";
          //     this.tips.show_type="eva_show";
          //   }
          // }
        });
      },
      setData() {
        const {page, pid, cid, time, status,class_level,class_train_type} = this.$route.query;
        page && (this.page = page);
        pid && (this.$set(this.search, "class_province_id", pid));
        pid && (this.getCityList());
        cid && (this.$set(this.search, "class_city_id", cid));
        time && (this.$set(this.search, "class_create_time", time));
        status && (this.$set(this.search, "class_status", status));
        class_level && (this.$set(this.search, "class_level", class_level));
        class_train_type && (this.$set(this.search, "class_train_type", class_train_type));
      },
      getClassList() {
        this.showList = false;
        userClassList({"page": this.page, ...this.search})
          .then(res => {
            const {result} = res.data;
            this.$set(this.paging, "prePage", result.page.page_size);
            this.$set(this.paging, "total", result.page.total_row);
            this.$set(this.paging, "start", (this.page - 1) * this.paging.prePage);
            this.classNum=result.class_num;
            this.isShowPromote=result.isShowPromote;
            this.list = result.list;
            if(this.list.length > 0) {
              this.showList = true;
              this.showEmpty = false;
            } else {
              this.showList = false;
              this.showEmpty = true;
            }
            this.scrollTop = 0;
          })
          .catch(err => {
            console.error(err);
          });
      },
      imgErr() {
        this.$set(this.userInfo, "profile_picture", userImg);
      },
      imgListErr(idx) {
        this.$set(this.list[idx], 'moment_picture', this.classImg);
      },
      gotoPage(start) {
        this.page = parseInt(start / this.paging.prePage) + 1;
        this.changeQuery(false);
      },
      change_req() {
        this.changeQuery(true);
        this.showList && this.$refs['vs'].scrollTo({ y: 0 });
      },
      updateCity() {
        this.$set(this.search, "class_city_id", "");
        this.getCityList();
        this.change_req();
      },
      getCityList() {
        const city = this.$yioks.updateCity(this.search.class_province_id, this.filterData.area);
        this.$set(this.filterData, "city", city);
      },
      changeQuery(flag) {
        flag && (this.page = 1);
        this.$router.replace({
          path: this.$route.path,
          query: {
            ...this.$route.query,
            page: this.page,
            pid: this.search.class_province_id,
            cid: this.search.class_city_id,
            time: this.search.class_create_time,
            status: this.search.class_status,
            class_level: this.search.class_level,
            class_train_type: this.search.class_train_type,
          }
        });
        this.getClassList();
      },
      lookOver(id) {
        this.$router.push({path: "tea_cd", query: {c_id: id}});
      },
      viewResult(obj){
        this.verifyResult = true;
        this.verifyMsg = obj;
      },
      showPromote(){
        this.isLoading=true;
        teacher_promote_list({
          teacher_id:this.userInfo.user_id
        }).then(res=>{
          if (res.data.status===0){
            const {promoteList}=res.data.result;
            this.promoteList=promoteList;
            if (this.promoteList.length>0){
              this.promoteNum=this.promoteList[0].promote_number
              this.cId = this.promoteList[0].c_id;
              this.teacherId = this.promoteList[0].teacher_id;
              this.promoteType = "promote";
              this.ShowEvaluate=true
            }else{
              this.showPromoteEmpty=true;
            }
            this.isLoading=false;
          } else {
            this.isLoading=false;
          }
        }).catch(err=>{
          this.isLoading=false;
        })
      },
      gotoMyTutorial(){
        this.$router.push("tutorial_list");
      },
      getPromoteData(){
        this.promoteList.forEach(item => {
          if(item.promote_number === this.promoteNum){
            this.cId = item.c_id;
            this.teacherId = item.teacher_id
          }
        });
      },
    }
  }
</script>

<style lang="stylus" scoped>
  @import "~@/assets/css/variable";
  @import "~@/assets/css/mixin";
  .teaLeft, .teaRight {
    flex: 1 1 auto;
    height: 100%;
  }

  .teaLeft {
    padding: 60px 10px 0;
    width:100%;
    .info {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      img {
        width: 115px;
        height: 115px;
        border-radius: 50%;
      }
      .name {
        margin: 20px 0 6px;
        width:100%;
        /*padding: 0 15px;*/
        font-size: 18px;
        text-align:center
        // word-break break-word
        word-break break-all
        word-wrap break-word
      }
      .num {
        font-size: $font_size_big;
      }
      .tea_history{
        margin-top 20px
        .promote_tea{
          width 150px
          border-radius 0
        }
      }
    }
  }

  .teaRight {
    width: 100%;
    .rightHead {
      padding: 15px 0;
      margin: 0 30px 0 15px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid $color_white;
      p {
        font-size: 22px;
      }
      .selectWrap {
        select {
          height: 35px;
          margin: 0 0 0 5px;
          padding: 0 0 0 5px;
          color: $color_black;
          font-size: $font_size_base;
        }
        .search {
          width: 99px;
        }
      }
    }
    .rightBody {
      width: 100%;
      height: calc(100% - 66px);
      .scrollArea {
        width: 100%;
        height: calc(100% - 77px);
        padding: 15px 0 0;
        .tbodyWrap {
          padding: 0 30px 0 15px;
          .tbody {
            .tr {
              display: flex;
              /*height: 155px;*/
              margin: 0 0 15px
              &:last-child {
                margin-bottom 0
              }
              /*.term {
                width: 45px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                border: 1px solid $color_white;
                user-select: none;
              }*/
              .detail {
                flex: 1 1 auto;
                /*margin: 0 0 0 15px;*/
                padding: 10px;
                border: 1px solid $color_white;
                .title {
                  font-size: $font_size_class_name;
                }
                .blockWrap {
                  display: flex;
                  justify-content: space-between;
                  /*align-items: center;*/
                  .left {
                    flex: 1 1 auto;
                    .wrap {
                      margin: 5px 0 0;
                      display: flex;
                      .imgWrap {
                        flex: 0 0 auto;
                        width: 135px;
                        height: 100px;
                        position: relative;
                        img {
                          width: 100%;
                          height: 100%;
                        }
                      }
                      .infoWrap {
                        max-width: 350px;
                        padding: 0 0 0 20px;
                        line-height: 16px;
                        flex: 1 1 auto;
                        display: flex;
                        flex-direction: column;
                        justify-content: space-around;
                        font-size: $font_size_medium;
                        height: 100px;
                        p {
                          max-width: 445px;
                          over_hide();
                        }
                      }
                    }
                  }
                  .right {
                    padding: 20px 0 0;
                    display: flex;
                    flex-direction:column;
                    justify-content: center;
                    /*align-items: center;*/
                    .btn {
                      width: 110px;
                      height: 35px;
                      display: flex;
                      justify-content: center;
                      align-items: center;
                      font-size: $font_size_medium;
                      line-height: $font_size_medium;
                      background-color: $color_suc;
                      cursor: pointer;
                      user-select: none;
                      margin:5px 0 ;
                    }
                  }
                }
              }
            }
          }
        }
      }
      #paging {
        width: 100%;
        height: 77px;
      }
    }
  }
  .eval-dialog
      .to-eval
        font-size 16px
        text-align center
        img
          width 100px
        .tips
          margin-bottom 15px
  .detail-info-dia-date
    .scroll-wrap
      display block
      height 530px
      overflow hidden
      position relative
      .stu-info-box
        display block
        padding 0 15px
        font-size $font_size_medium

  .promoteWrap
    position absolute
    right 38px
    top 10px
    select
      width: 130px;
      height: 35px;
      margin: 0 0 0 10px;
      padding: 0 25px;
      font-size: $font_size_medium;
      color: $color_black;
</style>
